import { Competitors } from "app/pages/activation/components/Settings/Competitors/Competitors";
import * as SC from "app/pages/activation/components/Settings/TabsContent/styles";
import { CompetitorActions } from "app/pages/activation/modules/Settings/types";

import { generateAutomationName } from "../../../../helpers/generateAutomationName";

import type { CompetitorsSectionSchema } from "./type";

export const CompetitorsSection = ({
    setIsChanged,
    dispatchCompetitors,
    competitors,
    isLoadingCompetitors,
    isFetchingCompetitors,
    selectedWebsite,
    isViewerMode,
}: CompetitorsSectionSchema) => (
    <SC.Section
        withSeparator
        className="noTopPadding"
        data-automation={generateAutomationName("settings", ["section", "competitors"])}
    >
        <Competitors
            isLoading={isLoadingCompetitors || isFetchingCompetitors}
            addCompetitor={(selectedItem, assetKey) => {
                dispatchCompetitors({
                    type: CompetitorActions.add,
                    payload: { selectedItem, assetKey },
                });
                setIsChanged(true);
            }}
            removeCompetitor={(selectedItem, assetKey) => {
                dispatchCompetitors({
                    type: CompetitorActions.remove,
                    payload: { selectedItem, assetKey },
                });
                setIsChanged(true);
            }}
            removeAllCompetitors={(selectedItem, assetKey) => {
                dispatchCompetitors({
                    type: CompetitorActions.removeAll,
                    payload: { selectedItem, assetKey },
                });
                setIsChanged(true);
            }}
            allCompetitors={competitors}
            selectedMainDomain={selectedWebsite}
            isViewerMode={isViewerMode}
        />
    </SC.Section>
);
